$(function() {

    // unsubscribe button confirm
    $('.jsUnsubscribeNotifications').click(function(e){
        let message = $(this).data('confirm');

        if ( !confirm(message) )
        {
            e.preventDefault();
        }
    });
});